import { v1ApiClient } from '@/services';

import type { CreateChartPayload } from './types';

export const updateChart = async (
  alias: string,
  chartState: CreateChartPayload,
): Promise<ChartItem> => {
  const res = await v1ApiClient.put<ChartItem>(`/charts/${alias}`, chartState);
  return res.data;
};
